
import {mapState, mapActions} from "pinia";
import BaseBtModal from "@vueEntry/BaseBtModal.vue";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseSelect from "@vueEntry/UIKitComponents/BaseSelect.vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import {useBreakpoints}  from "@wkComposables/useBreakpoints";
import {defineComponent} from "vue";
import {useAgencyFilters} from "@wkComposables/useAgencyFilters"
import {useSearchBeanStore} from "@store/SearchBeanStore";


export default defineComponent(
    {
        name: "FiltersAgencyModal",
        //TODO: da chiedere a stefano perchè c'era un toggle (alla fine non veniva utilizzato)
        components: {BaseBtModal, BaseSelect, BaseButton, BaseInput},
        props: {
            showFiltersAgencyModal: {
                type: Boolean
            },
            listing: {
                type: Boolean,
                default: false
            },
            agencyGroup: {
                type: String,
                default: ""
            },
            agencyGroupName: {
                type: String,
                default: ""
            }
        },
        emits: ["filter-agency-modal", "hide-agency-filter-modal"],
        setup(){
            const {isDesktopMode} = useBreakpoints()
            const {
                agencyFilter,
                currentSearchFranchiseIdName,
                currentSearchName,
                franchiseList,
                currentSearchFranchiseOptions,
                labels
            } = useAgencyFilters()
            return {
                isDesktopMode,
                //useAgencyFilters
                agencyFilter,
                currentSearchFranchiseIdName,
                currentSearchName,
                franchiseList,
                currentSearchFranchiseOptions,
                labels
            }
        },
        data() {
            return {
                show: false,
            }
        },
        computed: {
            ...mapState(useSearchBeanStore, ["searchBean"])
        },
        created() {
            this.show = this.showFiltersAgencyModal;
            this.agencyFilter.name = this.currentSearchName;
            /*  this.agencyFilter.franchiseId = this.currentSearchFranchiseId;*/
            this.currentSearchFranchiseIdName = this.agencyGroupName ?? "";
            this.agencyFilter.uri = this.agencyGroup ?? "";
        },
        methods: {
            confirmFilter(): void {
                this.$emit("filter-agency-modal", this.agencyFilter);
            },
            hideAgencyFiltersModal() {
                this.$emit("hide-agency-filter-modal");
            },
            // ...mapMutations(["setSearchBean", "setSearchBeanByKey", "updateSearchBean"])
            ...mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"])
        }
    }
)
